<template>
  <v-container fluid grid-list-xl pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-toolbar-title>
        <v-flex pl-4 class="d-flex align-center">
          <v-combobox
            class="width-300 text-xs-left"
            name="bonusCategoryType"
            v-validate="'required'"
            :error-messages="errors.collect('select.bonusCategoryType')"
            v-model="bonusCategoryType"
            :items="items"
            flat
            item-text="title"
            :allow-overflow="false"
            type="button"
            single-line
            return-object
          >
            <template slot="selection" slot-scope="data">
              <div>
                <span style="color:#005cae">{{data.item.title}}</span>
              </div>
            </template>
          </v-combobox>
        <!-- 124840 Tutorial ingreso automático de facturas -->
        <a href="#" @click.prevent="showManualModal = true" style="color: #005cae; text-decoration: none; margin-left: 4rem; font-size: 14px;">
            <v-icon small class="fas fa-hand-point-right mr-1 mb-1"></v-icon>
            Tutorial para ingreso automático de facturas
          </a>
        </v-flex>
        
        <v-dialog v-model="showManualModal" max-width="600px">
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Ingreso automático de Facturas</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="showManualModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="height: 380px;">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/ARThFuES_Bc?si=Nf9whtGMulcWZ160" title="Ingreso automático de facturas" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items style="margin-right: 1.5% !important;" v-if="bonusCategoryType">
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-left: 5% !important;"
          small
          v-if="bonusCategoryType.id==1 && showButtonGenerate"
          @click="sendBonusCategoryPreliquidationGeneration"
          color="accent"
        >Generar</v-btn>
        <v-btn
          class="hidden-xs-only"
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          style="height:50%;margin-right: 3% !important;"
          small
          v-if="bonusCategoryType.id==2 && !bonusCategoryPermissionApproveAndBill&&$refs.preAproveList!=null"
          @click="sendBonusCategoryPreliquidationApprove"
          color="accent"
        >Aprobar</v-btn>
        <v-btn
          class="hidden-xs-only"
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          style="height:50%;margin-right: 3% !important;"
          small
          v-if="bonusCategoryType.id==2 && bonusCategoryPermissionApproveAndBill&&$refs.preAproveList!=null"
          @click="sendBonusCategoryPreliquidationApprove"
          color="accent"
        >Aprobar</v-btn><!-- 
        <v-btn
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          class="hidden-xs-only"
          style="height:50%;margin-right: 3% !important;"
          small
          v-if="bonusCategoryType.id==2 && bonusCategoryPermissionApproveAndBill&&$refs.preAproveList!=null"
          @click="sendBonusCategoryPreliquidationApproveAndBill()&&$refs.preAproveList!=null"
          color="accent"
        >Aprobar y facturar</v-btn> -->
        <v-btn
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          class="hidden-xs-only"
          style="height:50%;margin-right: -1.6% !important;"
          small
          v-if="bonusCategoryType.id==2&&$refs.preAproveList!=null"
          @click="sendBonusCategoryPreliquidationReject"
          color="accent"
        >Rechazar</v-btn>

        <v-menu style="margin-left: 4% !important;" bottom left>
          <v-btn slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            
            <v-list-tile
              class="hidden-xs-only"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusCategoryType.id==2 && bonusCategoryPermissionApproveAndBill&&$refs.preAproveList!=null"
              @click="sendBonusCategoryPreliquidationApproveAndBill()"
            >
            <v-list-tile-title>Aprobar y facturar</v-list-tile-title>
            </v-list-tile>
            <!-- <v-list-tile
              class="hidden-xs-only"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusCategoryType.id==2 && $refs.preAproveList!=null"
              @click="sendBonusCategoryDetail()"
            >
            <v-list-tile-title>Ver Detalle</v-list-tile-title>
            </v-list-tile> -->
            <v-list-tile @click="generateExcel">
              <v-list-tile-title>Generar archivo excel</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="generatePDF">
              <v-list-tile-title>Generar archivo pdf</v-list-tile-title>
            </v-list-tile>

            <v-list-tile class="hidden-sm-and-up" v-if="bonusCategoryType.id==1 && showButtonGenerate">
              <v-list-tile-title @click="sendBonusCategoryPreliquidationGeneration">Generar</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusCategoryType.id==2 && !bonusCategoryPermissionApproveAndBill&&$refs.preAproveList!=null"
              @click="sendBonusCategoryPreliquidationApprove"
            >
              <v-list-tile-title >Aprobar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusCategoryType.id==2 && bonusCategoryPermissionApproveAndBill&&$refs.preAproveList!=null"
               @click="sendBonusCategoryPreliquidationApprove"
            >
              <v-list-tile-title>Aprobar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusCategoryType.id==2 && bonusCategoryPermissionApproveAndBill&&$refs.preAproveList!=null"
               @click="sendBonusCategoryPreliquidationApproveAndBill()"
            >
              <v-list-tile-title
               
              >Aprobar y facturar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              v-if="bonusCategoryType.id==2&&$refs.preAproveList!=null"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              @click="sendBonusCategoryPreliquidationReject"
            >
              <v-list-tile-title >Rechazar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <preliquidation-generation v-if="bonusCategoryType && bonusCategoryType.id==1"></preliquidation-generation>
    <preliquidation-approval
      ref="preAproveList"
      v-if="bonusCategoryType && bonusCategoryType.id==2"
    ></preliquidation-approval>
    <liquidation-query ref="liqQuery" v-if="bonusCategoryType && bonusCategoryType.id==3"></liquidation-query>
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { downloadPDF, isPdfArrayBuffer } from "@/common/helpers/helpers";
import { downloadEXCEL } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

import PreliquidationGeneration from "./PreliquidationGeneration.vue";
import PreliquidationApproval from "./PreliquidationApproval.vue";
import LiquidationQuery from "./LiquidationQuery.vue";
import DetailLiquidation from "./DetailLiquidation.vue";

export default {
  components: {
    PreliquidationGeneration,
    PreliquidationApproval,
    LiquidationQuery,
    DetailLiquidation
  },
  computed: {
    ...mapGetters([
      "bonusCategorySelected",
      "bonusCategoryPermissionApproveAndBill",
      "bonusCategoryPendingPdf",
      "bonusCategoryPendingExcel",
      "bonusCategoryPdf",
      "bonusCategoryExcel",
      "userId",
      "isBrokerBonusCategory"
    ])
  },
  async mounted() {
    this.$store.dispatch("getUserId");
    this.bonusCategoryType = this.items[0];
    this.$store.dispatch("bonusCategoryPreliquidationValidatePermission");
    await this.$store.dispatch("validateIsUserAgentBonusCategory", this.userId);
    this.showButtonGenerate = this.isBrokerBonusCategory;
  },
  methods: {
    sendBonusCategoryPreliquidationGeneration() {
      this.$store
        .dispatch("sendBonusCategoryPreliquidationGeneration")
        .then(res => {
          this.$store.dispatch("getBonusCategoryPending");
        });
    },
    sendBonusCategoryPreliquidationApprove() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusCategoryPreliquidationApprove",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar el bono por Categoria",
          "error"
        );
      }
    },
    sendBonusCategoryPreliquidationApproveAndBill() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusCategoryPreliquidationApproveAndBill",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar el bono por categoria",
          "error"
        );
      }
    },
    sendBonusCategoryPreliquidationReject() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusCategoryPreliquidationReject",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar el bono por categoria",
          "error"
        );
      }
    },
    generatePDF() {
      switch (this.bonusCategoryType.id) {
        case 1:
          this.$store.dispatch("getBonusCategoryPendingPdf").then(res => {
            if (
              !isPdfArrayBuffer(this.bonusCategoryPendingPdf)
              || this.bonusCategoryPendingPdf.byteLength < 200
            ) {
              this.$root.$emit(
                "showSnackBar",
                "Error generando el pdf",
                "error"
              );
              return;
            }
            downloadPDF(this.bonusCategoryPendingPdf, "preliquidaciones.pdf");
          });
          break;
        case 2:
          if (this.$refs.preAproveList.selectedValue != null) {
            this.$store
              .dispatch(
                "getBonusCategoryPreliminarPdf",
                this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (
                  !isPdfArrayBuffer(this.bonusCategoryPdf)
                  || this.bonusCategoryPdf.byteLength < 200
                ) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el pdf",
                    "error"
                  );
                  return;
                }
                downloadPDF(
                  this.bonusCategoryPdf,
                  `bonos-categoria-detalles-${
                    this.$refs.preAproveList.selectedValue
                  }.pdf`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por categoria",
              "warning"
            );
          }

          break;
        case 3:
          if (this.$refs.liqQuery.selectedValue != null) {
            this.$store
              .dispatch(
                "getBonusCategoryPdf",
                this.$refs.liqQuery.selectedValue
              )
              .then(res => {
                if (
                  !isPdfArrayBuffer(this.bonusCategoryPdf)
                  || this.bonusCategoryPdf.byteLength < 200
                ) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el pdf",
                    "error"
                  );
                  return;
                }
                downloadPDF(
                  this.bonusCategoryPdf,
                  `bonos-categoria-detalles-${
                    this.$refs.liqQuery.selectedValue
                  }.pdf`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por categoria",
              "warning"
            );
          }
          break;
      }
    },
    generateExcel() {
      switch (this.bonusCategoryType.id) {
        case 1:
          this.$store.dispatch("getBonusCategoryPendingExcel").then(res => {
            if (
              this.bonusCategoryPendingExcel.byteLength < 200 ||
              this.bonusCategoryPendingExcel.length < 200
            ) {
              this.$root.$emit(
                "showSnackBar",
                "Error generando el excel", //this.bonusCategoryPendingExcel.data,
                "error"
              );
              return;
            } else {
              downloadEXCEL(
                this.bonusCategoryPendingExcel,
                "bonos-categoria-pendientes.xlsx"
              );
            }
          });
          break;
        case 2:
          if (this.$refs.preAproveList.selectedValue != null) {
            this.$store
              .dispatch(
                "getBonusCategoryExcel",
                this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (this.bonusCategoryExcel.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el excel", //this.bonusCategoryExcel.data,
                    "error"
                  );
                  return;
                }
                downloadEXCEL(
                  this.bonusCategoryExcel,
                  `bonos-categoria-detalles-${
                    this.$refs.preAproveList.selectedValue
                  }.xlsx`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por categoria",
              "warning"
            );
          }

          break;
        case 3:
          if (this.$refs.liqQuery.selectedValue) {
            this.$store
              .dispatch(
                "getBonusCategoryExcel",
                this.$refs.liqQuery.selectedValue
              )
              .then(res => {
                if (this.bonusCategoryExcel.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el excel", //this.bonusCategoryExcel.data,
                    "error"
                  );
                  return;
                }
                downloadEXCEL(
                  this.bonusCategoryExcel,
                  `bonos-categoria-detalles-${
                    this.$refs.liqQuery.selectedValue
                  }.xlsx`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por categoria",
              "warning"
            );
          }
          break;
      }
    },
    sendBonusCategoryDetail(){
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusCategoryDetail",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar el bono por Categoria",
          "error"
        );
      }
    }
  },
  data() {
    return {
      items: [
        {
          id: 1,
          title: i18n.t("message.preliquidationGeneration")
        },
        {
          id: 2,
          title: i18n.t("message.preliquidationApproval")
        },
        {
          id: 3,
          title: i18n.t("message.liquidationQuery")
        }
      ],
      bonusCategoryType: undefined,
      showManualModal: false,
      showButtonGenerate: false
    };
  }
};
</script>